import { AnalysisRepository } from '@telespot/domain';

export interface CountAlgorithmAnalyzedAssetsParams {
  sampleId: string;
  algorithmId: string;
  assetIds: string[];
}

export interface AlgorithmAnalyzedAssetsCount {
  /** Assets with a successful analysis by the algorithm. */
  analyzed: number;
  /** Assets whose analysis recorded a terminal failure. */
  failed: number;
}

export class AlgorithmAnalyzedAssetsCounter {
  constructor(private readonly analysis: AnalysisRepository) {}

  public async count(params: CountAlgorithmAnalyzedAssetsParams): Promise<AlgorithmAnalyzedAssetsCount> {
    const { sampleId, algorithmId, assetIds } = params;

    if (assetIds.length === 0) {
      return { analyzed: 0, failed: 0 };
    }

    const analyzedAssetIds = new Set<string>();
    const failedAssetIds = new Set<string>();
    const analyzerEntity = 'algorithm' as const;

    const analysisBatches = this.analysis.findForAssets(assetIds, {
      analyzerEntity,
      analyzerId: algorithmId,
      sampleId,
    });

    for await (const analyses of analysisBatches) {
      for (const analysis of analyses) {
        if (!analysis.assetId) continue;

        if (analysis.hasError) {
          failedAssetIds.add(analysis.assetId);
        } else {
          analyzedAssetIds.add(analysis.assetId);
        }
      }
    }

    // A successful analysis supersedes any failure recorded for the asset.
    for (const assetId of analyzedAssetIds) {
      failedAssetIds.delete(assetId);
    }

    return { analyzed: analyzedAssetIds.size, failed: failedAssetIds.size };
  }
}
